export default __webpack_public_path__ + "static/media/team5.5dd66df2.png";